import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import uberhubLogo from '../assets/uberhub-logo.png';

const Header = () => {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();

  const closeMenu = () => setOpen(false);

  const handleLogout = async () => {
    await logout();
    closeMenu();
  };

  const navLinkClass = ({ isActive }: { isActive: boolean }) =>
    `nav-link px-3 fw-semibold ${isActive ? 'active text-white' : 'text-white-50'}`;

  return (
    <header className="navbar-wrapper shadow-sm">
      <nav className="navbar navbar-expand-lg navbar-dark container py-3">
        <Link className="navbar-brand d-flex align-items-center gap-2" to="/" onClick={closeMenu}>
          <img src={uberhubLogo} alt="UberHub" className="brand-logo brand-logo-pref" />
          <div className="d-flex flex-column lh-1">
            <span className="fw-bold">Calendário de Inovação</span>
            <small className="text-white-50">Agenda e envios</small>
          </div>
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          aria-expanded={open}
          aria-label="Alternar navegação"
          onClick={() => setOpen((current) => !current)}
        >
          <span className="navbar-toggler-icon" />
        </button>

        <div className={`collapse navbar-collapse justify-content-end ${open ? 'show' : ''}`}>
          <ul className="navbar-nav align-items-lg-center">
            <li className="nav-item">
              <NavLink to="/" className={navLinkClass} onClick={closeMenu} end>
                Calendário
              </NavLink>
            </li>
            {user && (
              <li className="nav-item">
                <NavLink to="/portal" className={navLinkClass} onClick={closeMenu}>
                  Portal do Solicitante
                </NavLink>
              </li>
            )}
            {user?.role === 'admin' && (
              <li className="nav-item">
                <NavLink to="/admin" className={navLinkClass} onClick={closeMenu}>
                  Admin
                </NavLink>
              </li>
            )}
          </ul>

          <div className="d-none d-lg-flex ms-3 align-items-center gap-2">
            {user ? (
              <>
                <span className="text-white-50 small text-end">
                  <strong className="d-block text-white">{user.name}</strong>
                  {user.email}
                </span>
                <button type="button" className="btn btn-outline-light" onClick={handleLogout}>
                  Sair
                </button>
              </>
            ) : (
              <Link to="/acesso" className="btn btn-brand px-4 fw-semibold" onClick={closeMenu}>
                Portal do Solicitante
              </Link>
            )}
          </div>

          <div className="d-lg-none mt-3">
            {user ? (
              <button type="button" className="btn btn-outline-light w-100" onClick={handleLogout}>
                Sair
              </button>
            ) : (
              <Link to="/acesso" className="btn btn-brand w-100 fw-semibold" onClick={closeMenu}>
                Portal do Solicitante
              </Link>
            )}
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
